import { useSearchConversationIdsQuery } from 'generated-graphql/hooks/apollo-hooks';
import {
  SearchableConversationSortableFields,
  SearchableSortDirection
} from 'generated-graphql/types';
import { useMemo } from 'react';

// Cap the result set — the indicator only needs presence, not an
// exhaustive list. Tens of thousands of unresolved more-time requests
// across one org would already be a bigger story than a missing icon.
const SEARCH_LIMIT = 1000;

export const useCampaignIdsWithMoreTimeRequested = (
  organizationId: string | undefined
) => {
  const { data, loading } = useSearchConversationIdsQuery({
    variables: {
      filter: {
        organizationId: { eq: organizationId ?? '' },
        unresolvedNeedsReviewReasons: { eq: 'MORE_TIME_REQUESTED' }
      },
      sort: {
        field: SearchableConversationSortableFields.UpdatedAt,
        direction: SearchableSortDirection.Desc
      },
      from: 0,
      limit: SEARCH_LIMIT
    },
    skip: !organizationId,
    fetchPolicy: 'cache-and-network'
  });

  const campaignIds = useMemo(() => {
    const ids = new Set<string>();
    (data?.searchConversations?.items ?? []).forEach((item) => {
      if (item?.campaignId) {
        ids.add(item.campaignId);
      }
    });
    return ids;
  }, [data]);

  return { campaignIds, loading };
};
